import { ActionTypes } from '../actions';

const initialState = {
  all: [],
  current: {},
};

const BooksReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_BOOKS:
      return { all: action.payload, current: state.current };
    case ActionTypes.FETCH_BOOK:
      return { all: state.all, current: action.payload };
    default:
      return state;
  }
};

export default BooksReducer;
